import { z } from 'zod/v3';

// Git configuration schema
export const GitConfigDTOSchema = z.object({
  repository: z.string(),
  branch: z.string().default('main'),
  createPR: z.boolean().optional(),
  prTitle: z.string().optional(),
  prBody: z.string().optional(),
  triggerEvents: z.array(z.object({
    type: z.enum(['slack', 'zendesk', 'intercom', 'github_issue', 'github_pr', 'knowledge_gap', 'other']),
    title: z.string(),
    deepguideUrl: z.string().url().optional(),
    externalUrl: z.string().url().optional(),
    id: z.string().optional(),
  })).optional(),
  triggerEventSourceIds: z.array(z.string()).optional(),
}).strict();

// Asset configuration schema
export const AssetConfigDTOSchema = z.object({
  baseUrl: z.string().optional(),
  strategy: z.enum(['reference', 'copy']),
  authentication: z.object({
    type: z.enum(['none', 'header', 'query']),
    credentials: z.record(z.string()).optional(),
  }).optional(),
}).strict();

// Initialize site schema
export const InitSiteDTOSchema = z.object({
  platform: z.enum(['docusaurus', 'vitepress']),
  repository: z.string(),
}).strict();

// Publish site schema
export const PublishSiteDTOSchema = z.object({
  workspaceId: z.string(),
  platform: z.enum(['docusaurus', 'vitepress']),
  git: GitConfigDTOSchema,
  assets: AssetConfigDTOSchema,
}).strict();

// Export types
export type GitConfigDTO = z.infer<typeof GitConfigDTOSchema>;
export type AssetConfigDTO = z.infer<typeof AssetConfigDTOSchema>;
export type InitSiteDTO = z.infer<typeof InitSiteDTOSchema>;
export type PublishSiteDTO = z.infer<typeof PublishSiteDTOSchema>; 
